
import { supabase } from "@/lib/supabase";
import { toast } from "@/hooks/use-toast";
import { generateAIResponse } from "@/utils/api/ai-generation";

// Generate AI response for the request
export const generateResponse = async (request: any, user: any | null): Promise<void> => {
  try {
    const aiResponse = await generateAIResponse(
      "initial", 
      request, 
      [],
      undefined,
      undefined,
      !user // Pass demo flag if not authenticated
    );
    
    if (aiResponse?.success && aiResponse?.response) {
      // For authenticated users, save to database
      if (user) {
        await supabase.from("messages").insert({
          refund_request_id: request.id,
          sender_type: "ai",
          content: aiResponse.response,
          tone: aiResponse.tone,
          metadata: {
            legalContext: aiResponse.legalContext
          }
        });
      }
      
      // Store AI response in the request object for demo mode
      request.aiResponse = aiResponse.response;
      request.tone = aiResponse.tone;
      request.legalContext = aiResponse.legalContext;
      
      toast({
        title: "Refund request created",
        description: `Your request has been submitted with a ${aiResponse.tone} tone email`,
        variant: "default",
      });
    } else {
      toast({
        title: "Refund request created",
        description: "Your request has been submitted, but we couldn't generate an email automatically",
      });
    }
  } catch (error) {
    console.error("Error generating AI response:", error);
    toast({
      title: "Refund request created",
      description: "Your request has been submitted, but we couldn't generate an email automatically",
    });
  }
};
